import { useUserStore } from '@/store/user';
import { updateAuth } from '@/utils/supabase';
import { Redirect } from 'expo-router';
import { useEffect, useState } from 'react';

export default function Index() {
  const [isLoading, setIsLoading] = useState(true);
  const { user } = useUserStore();

  useEffect(() => {
    const init = async () => {
      await updateAuth;
      setIsLoading(false);
    };

    init();
  }, []);

  if (!isLoading) {
    if (user?.isLoggedIn) {
      return <Redirect href="/(root)/(tabs)/Places" />;
    } else {
      return <Redirect href="./(auth)/login" />;
    }
  }
}
